import ReactDOM from 'react-dom';
import styles from './styles.module.scss';
import { useState } from 'react';
import Button from '@shared/componets/ui/Button/Button';



const ActionConfirm = ({
    active = true,
    description = 'Esta acción no se puede deshacer.',
    title = '¿Confirmar acción?',
    confirmText = 'Aceptar',
    cancelText = 'Cancelar',
    onConfirm,
    onCancel
}) => {
    const [animationActive, setAnimationActive] = useState(false);

    const clickOff = () => {
        if (animationActive) return;
        setAnimationActive(true);
        setTimeout(() => {
            setAnimationActive(false);
        }, 450);
    }


    return ReactDOM.createPortal(
        <div className={`${styles.content} ${active ? styles.contentActive : ''}`} >
            <div onClick={clickOff} className={styles.backdrop}></div>
            <div className={`${styles.actionConfirm} ${animationActive ? styles.animate : ''}`}>
                {title && <h3 className={styles.title}>{title}</h3>}
                <div>
                    {description && <div className={styles.description}>{description}</div>}
                </div>
                <div className={styles.butons}>
                    <Button
                        variant='btnRed'
                        onClick={onCancel}
                    >{cancelText}
                    </Button>
                    <Button
                        variant='btngreen'
                        onClick={onConfirm}
                    >{confirmText}
                    </Button>
                </div>
            </div>
        </div>
        , document.getElementById('portal-root'))
};

export default ActionConfirm;